import RetentionModal from '@/components/RetentionModal/src/main'
export default {
  install(Vue, options) {
    Vue.prototype.$retentionModal = (params) => {
      RetentionModal(options, params)
    }
  }
}